// Import model
import { StartEstimateAddSectionRequest } from '../models/StartEstimateAddSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateAddSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateAddSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateAddSectionRequest instance
   */
  static deserialize(json: string): StartEstimateAddSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateAddSectionRequest instance
   */
  static fromObject(obj: any): StartEstimateAddSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateAddSectionRequest');
    }


    const instance: StartEstimateAddSectionRequest = {
      name: obj['name'] as string | undefined,
      content: obj['content'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateAddSectionRequest instances
   */
  static deserializeArray(json: string): StartEstimateAddSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateAddSectionRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateAddSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateAddSectionRequest instance to a plain object
   */
  static toObject(instance: StartEstimateAddSectionRequest): any {
    return {
      'name': instance.name,
      'content': instance.content,
    };
  }

  /**
   * Serializes an array of StartEstimateAddSectionRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateAddSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
